import { FormProvider, useForm } from "react-hook-form";
import { useContext, useEffect, useState } from "react";
import { TransferOfGoodsModel } from "../models/TransferOfGoodsModel";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import { useAppSelector } from "src/redux/hooks/hooks";
import { selectSubmitCounter } from "src/redux/slices/submitCounterSlice";
import useRunError from "src/components/Shared/useRunError";
import { useFetchTransferOfGood } from "../hooks/fetchDocument";
import { importFromExcel } from "src/helpers/SaveObjectToExcel";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { TransferOfGoodsDetailMain } from "./TransferOfGoodsDetailMain";
import { TransferOfGoodsDetailProducts } from "./TransferOfGoodsDetailProducts";
import { TransferOfGoodsDetailAdditional } from "./TransferOfGoodsDetailAdditional";
import { TransferOfGoodsDetailFooter } from "./TransferOfGoodsDetailFooter";

interface IProps {
  id?: string;
}

export const TransferOfGoodsDetail = ({ id }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<TransferOfGoodsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("products");
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Transfer Of Goods");
  const counter = useAppSelector(selectSubmitCounter);
  const runError = useRunError(isValid, errors, counter);

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchTransferOfGood({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  useEffect(() => {
    if (
      errors.warehouseReceivingId?.type === "required" ||
      errors.warehouseExpensingId?.type === "required" ||
      errors.divisionId?.type === "required" ||
      errors.companyId?.type === "required"
    ) {
      runError();
    }
  }, [errors, runError]);

  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.TransferOfGoods.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar> */}

        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handlePost} />
          <DetailViewCancelButton onCancel={handleCancel} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <TransferOfGoodsDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <TransferOfGoodsDetailProducts />
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <TransferOfGoodsDetailAdditional />
        </NFTabContainer>
      </div>
      <TransferOfGoodsDetailFooter />
    </FormProvider>
  );
};
